import {createSelector} from "@reduxjs/toolkit";

export const driversSelector = (store) => store.drivers;

export const selectAllActiveDrivers = createSelector([driversSelector], (drivers) => drivers && drivers.drivers && drivers.drivers.filter((driver) => driver.status === 'active'));
